"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DepositSuccess_1 = __importDefault(require("./DepositSuccess"));
exports.default = DepositSuccess_1.default;
